import React from 'react'

import { isFunction } from 'lodash'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import MessageNotification from './MessageNotification'

export class DestinationNotification extends React.Component {
  goToDestination() {
    this.props.onMarkAsRead()
    const destination = this.props.destinations[this.props.item.Destination.Endpoint]
    if (destination) {
      let target = destination
      if (isFunction(destination)) {
        target = destination(this.props.item)
      }
      if (target) {
        this.props.history.push(target)
      }
    }
  }

  render() {
    return (
      <MessageNotification
        item={this.props.item}
        onClick={() => this.goToDestination()}
      />
    )
  }
}

DestinationNotification.propTypes = {
  item: PropTypes.object.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  destinations: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.func])).isRequired,
  onMarkAsRead: PropTypes.func.isRequired,
}

DestinationNotification.defaultProps = {
  destinations: {},
}
export default withRouter(DestinationNotification)
